// React
import { createContext } from "react"

export const DisableBillContext = createContext<{
  delivery: boolean
  deposit: boolean
}>({
  delivery: false,
  deposit: false
})